/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { InsuranceCompanySchema } from './InsuranceCompanySchema';
import type { InsurancePaymentTypeOptions } from './InsurancePaymentTypeOptions';
import type { InsuranceTypeOptions } from './InsuranceTypeOptions';
import type { LocationSchema } from './LocationSchema';
import type { SexOptions } from './SexOptions';
import type { TagSchema } from './TagSchema';
export type PatientSchemaPatientCount = {
    name: string;
    waiting: (string | null);
    sex: SexOptions;
    insurance_company: (InsuranceCompanySchema | null);
    insurance_type: (InsuranceTypeOptions | null);
    insurance_payment_type: (InsurancePaymentTypeOptions | null);
    location: (LocationSchema | null);
    tags: Array<TagSchema>;
    language: PatientSchemaPatientCount.language;
    absence_count?: (number | null);
    id?: (string | null);
    first_name?: (string | null);
    last_name: string;
    email_address?: (string | null);
    nin?: (string | null);
    phone?: (string | null);
    address?: (string | null);
    birth_date_year?: (number | null);
    birth_date_month?: (number | null);
    birth_date_day?: (number | null);
    gdpr_consent?: boolean;
    gdpr_confirm_date?: (string | null);
    note?: (string | null);
    legal_representative?: (string | null);
    insurance_number?: (string | null);
    insurance_company_change?: (string | null);
    patient_count?: (number | null);
    max_patients?: (number | null);
};
export namespace PatientSchemaPatientCount {
    export enum language {
        CS = 'cs',
        EN = 'en',
        SK = 'sk',
        PL = 'pl',
    }
}

